import { Routes } from '@angular/router';

export const planRoutes: Routes = [
    {
        path: 'list/:planType/:planTypeId',
        loadComponent: () =>
          import('../features/plan/page/plan.component')
            .then((m) => m.PlanComponent),
      },
      {
        path: 'list/:planType',
        loadComponent: () =>
          import('../features/plan/page/plan.component')
            .then((m) => m.PlanComponent),
      },
      {
        path: 'ke-hoach-tct/:planType/:planTypeId',
        loadComponent: () =>
          import('../features/plan/page/ke-hoach-tct/ke-hoach-tct.component')
            .then((m) => m.KeHoachTctComponent),
      },
      {
        path: 'ke-hoach-tct/:planType',
        loadComponent: () =>
          import('../features/plan/page/ke-hoach-tct/ke-hoach-tct.component')
            .then((m) => m.KeHoachTctComponent),
      },
      {
        path: 'ke-hoach-tct-chi-tiet/:keHoachId',
        loadComponent: () =>
          import('../features/plan/page/ke-hoach-tct-chi-tiet/ke-hoach-tct-chi-tiet.component')
            .then((m) => m.KeHoachTctChiTietComponent),
      },
      {
        path: 'ke-hoach-don-vi/:planType/:planTypeId',
        loadComponent: () =>
          import('../features/plan/page/ke-hoach-don-vi/ke-hoach-don-vi.component')
            .then((m) => m.KeHoachDonViComponent),
      },
      {
        path: 'ke-hoach-don-vi/:planType',
        loadComponent: () =>
          import('../features/plan/page/ke-hoach-don-vi/ke-hoach-don-vi.component')
            .then((m) => m.KeHoachDonViComponent),
      },
      {
        path: 'warehouse-sync',
        loadComponent: () =>
          import('../features/plan/page/ke-hoach-don-vi-warehouse-sync/ke-hoach-don-vi-warehouse-sync.component')
            .then((m) => m.KeHoachDonViWarehouseSyncComponent),
      },
      {
        path: 'versions',
        loadComponent: () =>
          import('../features/plan/page/template-version-page/template-version-page.component')
            .then((m) => m.PlanVersionPageComponent),
      },
      {
        path: 'version/detail',
        loadComponent: () =>
          import('../features/plan/page/template-version-detail-page/template-version-detail-page.component')
            .then((m) => m.PlanVersionDetailPageComponent),
      },
     {
        path: ':planType/:mode/:id',
        loadComponent: () =>
          import('../features/plan/component/chi-tiet-ke-hoach/chi-tiet-ke-hoach.component')
            .then((m) => m.ChiTietKeHoachComponent),
      },
      {
        path: ':planType/:mode/:id/:planOrgId',
        loadComponent: () =>
          import('../features/plan/component/chi-tiet-ke-hoach/chi-tiet-ke-hoach.component')
            .then((m) => m.ChiTietKeHoachComponent),
      },
 /*
{
        path: ':planType/:mode/:id',
        loadComponent: () =>
          import('../features/plan/component/detail-plan/detail-plan.component')
            .then((m) => m.DetailPlanComponent),
      },
      {
        path: ':planType/:mode/:id/:planOrgId',
        loadComponent: () =>
          import('../features/plan/component/detail-plan/detail-plan.component')
            .then((m) => m.DetailPlanComponent),
      },

*/
      {
        path: 'kehoachgiao/:id',
        loadComponent: () =>
          import('../features/plan/component/detail-assign-plan/detail-assign-plan.component')
            .then((m) => m.DetailAssignPlanComponent),
      },
      {
        path: 'kehoachthuchien/:id',
        loadComponent: () =>
          import('../features/plan/component/detail-perform-plan/detail-perform-plan.component')
            .then((m) => m.DetailPerformPlanComponent),
      },
      {
        path: 'periodic-reports',
        loadComponent: () =>
          import('../features/periodic-reports/page/periodic-reports.component')
            .then((m) => m.PeriodicReportsComponent),
      },
]